/*
 *
 * TeacherCommunicationDetailMobile constants
 *
 */

export const FLUSH_STATE = 'app/TeacherCommunicationDetailMobile/FLUSH_STATE';

export const LOAD_COMMUNICATION =
  'app/TeacherCommunicationDetailMobile/LOAD_COMMUNICATION';
export const LOAD_COMMUNICATION_SUCCESS =
  'app/TeacherCommunicationDetailMobile/LOAD_COMMUNICATION_SUCCESS';
export const LOAD_COMMUNICATION_ERROR =
  'app/TeacherCommunicationDetailMobile/LOAD_COMMUNICATION_ERROR';

  export const UPDATE_COMMUNICATION =
  'app/TeacherCommunicationDetailMobile/UPDATE_COMMUNICATION';
export const UPDATE_COMMUNICATION_SUCCESS =
  'app/TeacherCommunicationDetailMobile/UPDATE_COMMUNICATION_SUCCESS';
export const UPDATE_COMMUNICATION_ERROR =
  'app/TeacherCommunicationDetailMobile/UPDATE_COMMUNICATION_ERROR';